import { render } from "./weibo.svg?vue&type=template&id=1e569d40"
const script = {}
script.render = render

export default script